export default __webpack_public_path__ + "static/consumer-awards-edtech-breakthrough-5e0580fcbf87491d6fac2ac07827549a.png";